var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.userDetails)?_c('div',[_c('h4',[_vm._v("Recently Accessed Datasets")]),_c('div',_vm._l(((_vm.userDetails.recentTables || []).slice(0, 10).reverse()),function(table){return _c('a',{key:table.key,on:{"click":function($event){return _vm.setSelectedTreeItem({
          selectedTreeItem: `${table.cluster}.${table.database}.${table.schema}.${table.table_name}`
        })}}},[_c('div',{staticClass:"inline tag text-tile"},[_vm._v(" "+_vm._s(table.table_name)+" ")])])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }